import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import gift from '../../styles/img/gift.svg';
import v from '../../styles/img/arrow/v.svg';
import { ACCOUNT } from '../../constants/routes';
import PikkoPointBox from '../pikko-box/PikkoPointBox';

const AccountCard = ({ user, cartItems }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openStatut, setOpenStatut] = React.useState(false);

  return (
    <>
      {user && user._id && user._id.length > 0 ? (
        <div
          className={`recus flex flex-col justify-center items-center w-[90%] py-8 px-6 pt-10 rounded-[13px]  gap-4`}
          style={{ backgroundColor: '#FFF' }}
        >
          <PikkoPointBox click={() => navigate(ACCOUNT)} user={user} />
          {location && location.pathname !== '/scan' ? (
            <button
              className="payer p-6 rounded-[8px] mt-8 justify-self-end  w-full geomanistBold text-center text-[1.7rem] relative"
              onClick={() => navigate('/account')}
            >
              <span className="text-[1.7rem] geomanistBold">
                {' '}
                Voir mes récompenses
              </span>
            </button>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <div
          className={`recus flex flex-col justify-start items-center  w-full py-2 max-h-[90px] transition-all duration-300 px-4 pt-2 rounded-[10px]  overflow-hidden${openStatut ? ' max-h-[500px]' : ' max-h-[90px]'}`}
          style={{ backgroundColor: '#FFF', fontFamily: 'geomanistmedium' }}
          onClick={() => setOpenStatut(!openStatut)}
        >
          <div className="flex justify-center px-4 items-start w-full w-full flex text-start flex-col text-center ">
            <div className="flex ">
              <div className="text-[24px]  ">
                Créer un compte
                <p
                  className="text-[14px] pb-8 w-[85%]  "
                  style={{ fontFamily: 'Open Sans' }}
                >
                  Accède à de nombreux avantages avec un compte PikkoPay
                </p>
              </div>

              <div>
                <img
                  src={v}
                  alt="arrow"
                  className={
                    openStatut
                      ? ' transition-all rotate-180 mt-10'
                      : 'transition-all  mt-10'
                  }
                />
              </div>
            </div>
            <div
              className={`relative flex justify-around w-full px-10 opacity-0 transition-all duration-700 ${openStatut ? 'opacity-[1]' : ''}`}
            >
              <p className="flex flex-col gap-2 items-center geomanistBold justify-center w-24">
                <span className="geomanistBold text-[42px] flex gap-2">
                  5 <p>€</p>
                </span>
                <span className="geomanistBold text-3xl">offerts</span>
              </p>
              <p className="text-7xl pt-8 flex w-24 justify-center">+</p>
              <div className="flex flex-col items-center w-24">
                <img
                  className="relative  w-40 transform left-0  "
                  src={gift}
                  alt="gift"
                />
                <p className="text-xl geomanistBold"> Offres exclusives</p>
              </div>
            </div>
          </div>
          <button
            className="payer w-full p-6 text-[1.7rem] my-6 mt-10 "
            style={{ fontFamily: 'geomanistmedium' }}
            onClick={() =>
              navigate('/account', { state: { prevPage: 'ordersuccess' } })
            }
          >
            Me connecter / M'inscrire
          </button>
        </div>
      )}
    </>
  );
};

export default AccountCard;
